import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.ListD');
    return (
        <div className={styles.TheComp}>
            <EfSection label={t('label')} title={t('title')} desc={t('desc')} />
            <div className="ef-container ListD-list">
                <div className="ListD-item">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1725604062566/pc_charger%20methods01.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1725604099271/m_charger%20methods01.jpg"
                    />
                    <div className="text-content">
                        <p className="title">{t('method1_title')}</p>
                        <p className="desc">{t('method1_desc')}</p>
                    </div>
                </div>
                <div className="ListD-item">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1725604062685/pc_charger%20methods02.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1725604099629/m_charger%20methods02.jpg"
                    />
                    <div className="text-content">
                        <p className="title">{t('method2_title')}</p>
                        <p className="desc">{t('method2_desc')}</p>
                    </div>
                </div>
                <div className="ListD-item">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1725604062844/pc_charger%20methods03.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1725604099481/m_charger%20methods03.jpg"
                    />
                    <div className="text-content">
                        <p className="title">{t('method3_title')}</p>
                        <p className="desc">{t('method3_desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
